import { Avatar, AvatarProps, Radio, RadioProps } from '@mui/material';
import { Stack } from '@mui/system';
import { FunctionComponent } from 'react';
import { ActionBox } from '../action-box';
import { Spring } from '../spring';
import { TextHeader } from '../text-header';

export type SelectableCardProps = {
  avatarProps?: AvatarProps;
  subtitle: React.ReactNode;
  title: React.ReactNode;
  radioProps?: RadioProps;
  onClick?: () => void;
};

export const SelectableCard: FunctionComponent<SelectableCardProps> = (
  props,
) => {
  const { avatarProps, onClick, radioProps, subtitle, title } = props;
  return (
    <ActionBox borderRadius={2} padding={2}>
      <Stack direction="row" spacing={1} onClick={onClick}>
        <Avatar sx={{ alignSelf: 'center' }} {...avatarProps} />
        <Stack direction="column" alignSelf="flex-start">
          <TextHeader
            title={title}
            subtitle={subtitle}
            subtitleProps={{ display: 'block', variant: 'body2' }}
            titleProps={{ display: 'block', fontWeight: 700, variant: 'body1' }}
          />
        </Stack>
        <Spring />
        {radioProps && <Radio sx={{ alignSelf: 'center' }} {...radioProps} />}
      </Stack>
    </ActionBox>
  );
};
